export default __webpack_public_path__ + "static/media/crown-rank.204eaf9b.svg";